import { Model as a } from "../../../model.js";
class r extends a {
  constructor(s) {
    super(), this.internalLoyaltyId = s.internalLoyaltyId, this.loyaltyId = s.loyaltyId, this.balance = s.balance, this.accBalance = s.accBalance, this.maxBalance = s.maxBalance, this.userId = s.userId, this.userName = s.userName, this.userFullName = s.userFullName, this.status = s.status, this.loyalty = s.loyalty, this.tier = s.tier;
  }
}
export {
  r as LoyaltyAccountModel
};
//# sourceMappingURL=loyaltyAccount.model.js.map
